export const no = {
    LEFT: 'Venstre: Flytt til forrige dag.',
    RIGHT: 'Høyre: Flytt til neste dag.',
    DOWN: 'Ned: Flytte til neste rad.',
    UP: 'Opp: Flytt til forrige rad.',
    PGUP: 'PgUp: Flytt til forrige måned.',
    PGDOWN: 'PgDown: Gå til neste måned.',
    HOME: 'Home: Flytt til forrige år.',
    END: 'Slutt: Flytt til neste år.',
    ESC: 'Esc/i Dag/Lukk: lukker kalender.',
    TITLE: 'Tastatur Instruksjoner'
};
